export default __webpack_public_path__ + "static/media/SFProDisplay-Semibold.e563de5c.ttf";